document.addEventListener("DOMContentLoaded", function() {
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            const nextBtn = document.querySelector('.jdgm-write-review-modal__nav-btn-next');
            if(nextBtn && !nextBtn.querySelector('.icon-arrow-right')) {
                const span = document.createElement('span');
                span.className = 'icon icon-arrow-right';
                span.style.display = 'inline-flex'; // sorgt für saubere Ausrichtung
                span.style.marginLeft = '8px'; // Abstand zwischen Text und Pfeil

                span.innerHTML = `
<svg class="force-white" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <path d="M5 12H19" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12 5L19 12L12 19" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

                nextBtn.appendChild(span);
            }
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
});
